import { render } from "./ScatterPlot.vue?vue&type=template&id=94d462b4&scoped=true"
import script from "./ScatterPlot.vue?vue&type=script&lang=js"
export * from "./ScatterPlot.vue?vue&type=script&lang=js"

import "./ScatterPlot.vue?vue&type=style&index=0&id=94d462b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d462b4"]])

export default __exports__